import "core-js/modules/es6.array.map";
import "core-js/modules/es6.function.bind";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import React from "react";
import ClassNames from "classnames";

var NavMain =
/*#__PURE__*/
function (_React$Component) {
  _inherits(NavMain, _React$Component);

  function NavMain(props, state) {
    var _this;

    _classCallCheck(this, NavMain);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NavMain).call(this, props, state));
    _this.state = {
      active: false
    };
    _this.onClickToggle = _this.onClickToggle.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(NavMain, [{
    key: "onClickToggle",
    value: function onClickToggle(e) {
      e.preventDefault();
      var active = !this.state.active;
      this.setState({
        active: active
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var classNames = ClassNames("masthead__nav", "nav-main", {
        "nav-main--active": this.state.active
      });
      return React.createElement("nav", {
        className: classNames
      }, React.createElement("button", {
        onClick: this.onClickToggle,
        className: "btn--unstyled nav-main__toggle",
        title: "Mobile Navigation Toggle"
      }, React.createElement("i", {
        className: "far fa-bars"
      })), React.createElement("ul", {
        className: "nav-main__items"
      }, this.props.pages.map(function (_ref, i) {
        var label = _ref.label,
            path = _ref.path;
        var classNames = ClassNames({
          "nav-main__item": true,
          "nav-main__item--active": path === _this2.props.activePath
        });
        return React.createElement("li", {
          key: i,
          className: classNames
        }, React.createElement("a", {
          className: "nav-main__link",
          href: path
        }, label));
      })));
    }
  }]);

  return NavMain;
}(React.Component);

NavMain.defaultProps = {
  activePath: "/"
};
export default NavMain;